import { Component, inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { CheckCommentDialogForm } from './check-comment-dialog.form';

@Component({
  selector: 'qaroni-check-comment-dialog',
  templateUrl: './check-comment-dialog.component.html',
  styleUrls: ['./check-comment-dialog.component.scss'],
  standalone: false,
})
export class CheckCommentDialogComponent
  extends CheckCommentDialogForm
  implements OnInit
{
  checks = inject(MAT_DIALOG_DATA);
  dialogRef = inject<MatDialogRef<CheckCommentDialogComponent>>(MatDialogRef);

  ngOnInit(): void {
    if (this.checks && this.checks.length === 1) {
      this.checkId.setValue(this.checks[0].checkId);
      this.index.setValue(this.checks[0].index);
      this.comment.setValue(this.checks[0].comment);
    }
  }

  get validatedForm(): boolean {
    return this.dirtyValidForm && !this.submitting;
  }

  public onSubmit() {
    if (this.validatedForm) {
      this.dialogRef.close(this.form.value);
    }
  }

  public onCheckChange(event) {
    const check = this.checks.filter(check => check.checkId === event.value);
    this.index.setValue(check[0].index);
    this.comment.setValue(check[0].comment);
  }

  public onCancelClick(): void {
    this.dialogRef.close(null);
  }
}
